import React from 'react';
import {Link} from 'react-router-dom';
import _ListMenuFooter from './_ListMenuFooter.scss';
import NewsRegister from './NewsRegister.jsx';

class ListMenuFooter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [
        {
          title : 'DAKLAKTRADE',
          subMenu: [
            { link: '/cms/gioi-thieu-ve-san-tmdjt', text: 'Giới thiệu về Sàn TMĐT' },
            { link: '/cms/quy-che-hoat-djong', text: 'Quy chế hoạt động Sàn TMĐT' },
            { link: '/cms/djieu-khoan-and-djieu-kien-giao-dich', text: 'Điều khoản và điều kiện giao dịch' }
          ]
        },
        {
          title : 'DỊCH VỤ',
          subMenu: [
            { link: '/cms/trung-tam-ho-tro-khach-hang', text: 'Trung tâm Hỗ trợ khách hàng' },
            { link: '/cms/thanh-toan-an-toan', text: 'Thanh toán an toàn' },
            { link: '/cms/phuong-thuc-tham-gia', text: 'Phương thức tham gia' }
          ]
        },
        {
          title : 'NGƯỜI MUA',
          subMenu: [
            { link: '/cms/quy-djinh-djoi-voi-nguoi-mua', text: 'Quy định đối với người mua' },
            { link: '/cms/huong-dan-mua-hang', text: 'Hướng dẫn mua hàng' },
            { link: '/cms/co-che-giai-quyet-tranh-chap-phat-sinh', text: 'Cơ chế giải quyết tranh chấp phát sinh' }
          ]
        },
        {
          title : 'NGƯỜI BÁN',
          subMenu: [
            { link: '/cms/quy-djinh-djoi-voi-nguoi-ban', text: 'Quy định đối với người bán' },
            { link: '/cms/chinh-sach-bao-mat-thong-tin', text: 'Chính sách bảo mật thông tin' },
            { link: '/cms/huong-dan-dn-tham-gia-san', text: 'Hướng dẫn DN tham gia sàn' }
          ]
        }
      ]
    }
  }

  render() {
    return (
      <div className="wrap-list-menu-footer">
      {
        this.state.data.map((item,i) => {
          return (
            <div className='list-menu-footer' key={i}>
              <h3 className='title-menu-footer'>{item.title}</h3>
              <ul className='menu-footer'>
                {
                  item.subMenu.map((subMenu,j) => {
                    return(
                      <li className='item' key={j}><Link to={subMenu.link} className='item-link'>{subMenu.text}</Link></li>
                    )
                  })
                }
              </ul>
            </div>
          )
        })
      }
       <div className='list-menu-footer'>
          <h3 className='title-menu-footer'>Đăng kí nhận tin</h3>
          <NewsRegister/>
        </div>
      </div>
    );
  }
}

export default ListMenuFooter;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/ListMenuFooter.jsx